import React from 'react'

export const NGNCasesetFinished = ({ questionCount }) => (
  <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center p-4">
    <h4 className="mb-3">Caseset Complete</h4>
    <p className="text-muted mb-0">
      You have answered all {questionCount} question{questionCount !== 1 ? 's' : ''} in this caseset.
    </p>
  </div>
)
